import React, { useState } from "react";
import { registerNewResumen } from "./firebase";
import { SendEmail } from "./SendEmail";
import EndMessage from "./EndMessage";
import Select from "react-select";
import "./registro.css";

function Registro() {
  const [nombres, setNombres] = useState(null);
  const [correo, setCorreo] = useState(null);
  const [celular, setCelular] = useState(null);

  const [selectedOption, setSelectedOption] = useState(null);

  const [key, setKey] = useState("");
  const [state, SetState] = useState(0);

  const options = [
    { value: "Miembros de ASAEE", label: "Miembros de ASAEE" },
    { value: "Profesionales", label: "Profesionales" },
    {
      value: "Profesionales sin ponencia y estudiantes de posgrado",
      label: "Profesionales sin ponencia y estudiantes de posgrado",
    },
    { value: "Estudiantes de grado", label: "Estudiantes de grado" },
  ];

  function handleSubmit(e) {
    e.preventDefault();
    addPersonalData();
  }

  async function addPersonalData() {
    const data = {
      correo: correo,
      nombres: nombres,
      celular: celular,
      tipo_inscripcions: selectedOption.value,

      key: key,
    };

    const res = registerNewResumen(data);

    SetState(1);
  }

  return (
    <>
      {state === 0 && (
        <div className="wrapper-registroresumen">
          <h2>
            Formulario de <b> Preinscripción</b>
          </h2>
          <p>
            {" "}
            Este es un pre-registro. Próximamente recibirás un correo con los
            enlaces de pago y confirmación de tu inscripción.
          </p>
          <form action="" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="nombre">Nombres</label>

              <input
                type="text"
                name="nombre"
                placeholder="Escriba sus nombres y apellidos completos"
                onChange={(e) => setNombres(e.target.value)}
                required
              ></input>
            </div>

            <div>
              <label htmlFor="correo">Correo</label>

              <input
                type="text"
                name="correo"
                placeholder="Escriba el correo de contacto"
                onChange={(e) => setCorreo(e.target.value)}
                required
              ></input>
            </div>

            <div>
              <label htmlFor="celular">Celular</label>

              <input
                type="text"
                name="celular"
                placeholder="Escriba su número de celular"
                onChange={(e) => setCelular(e.target.value)}
                required
              ></input>
            </div>

            <div>
              <label>Tipo de inscripción </label>
              <Select
                defaultValue={selectedOption}
                onChange={setSelectedOption}
                options={options}
              />
            </div>

            <button>Enviar pre-registro</button>
          </form>
        </div>
      )}
      {state === 1 && <EndMessage></EndMessage>}
    </>
  );
}

export default Registro;
